<template>
<div class="styled-radio-container styled-radio-container--ou-donation row">
  <div v-for="[amount, description] of amounts" :key="amount" class="amount-row">
    <input :id="`amount${amount}`" type="radio" class="amount" @click="selectedAmount = amount" :checked="selectedAmount == amount">
    <FormLabel :for="`amount${amount}`">
      <span class="label-description">{{description}}</span>
      <MoneyFormat class="label-amount" :value="amount" :currencyCode="form.currency" :hide-subunits="true" />
    </FormLabel>	  
  </div>
  
  <div class="amount_other__wrapper amount-row">
      <input id="amount_other_check" type="radio" class="amount" :checked="customSelected" @click="customSelected = true">
      <input type="number" name="amount_other" placeholder="Other amount" v-model="customAmount" />
  </div>
</div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  ref,
  watch,
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

import type { Currency } from '~/form-settings'

export default defineComponent({  setup() {
    const { setValue, form, settings } = usePaymentForm()

    const selectedAmount = ref()
    const customAmount = ref(form.value.amount)
    const customSelected = ref(false)

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelected.value = false

        customAmount.value = null

        setValue('amount', '' + selectedAmount)
      }
    })

    watch(customSelected, (customSelected) => {
      if (customSelected) {
        selectedAmount.value = null
        setValue('amount', null)
      }
    })

    watch(customAmount, (customAmount) => {
      if (customAmount) {
        selectedAmount.value = null
        customSelected.value = true
      }

      if (!selectedAmount.value) setValue('amount', customAmount || null)
    })

    function clearOutSelectedValue() {
      selectedAmount.value = null
      setValue('amount', null)
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][]

      if (typeof amounts[0][0] == 'number') return amounts

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label])
    })

    return {
      form,
      amounts,
      selectedAmount,
      customAmount,
      clearOutSelectedValue,
      customSelected,
    }
  },
})
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;

  input[type='radio'] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    font-weight: bold;
    text-align: center;
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    overflow: hidden;
    padding: 15px 15px 5px;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 2px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: '$';
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: white;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:after {
      display: none !important;
    }
    input[type='number'] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
.amount-row {
  margin: 0 5px 15px;
  display: flex;
  align-items: center;
  width: 100%;
  @media (min-width: 720px) {
    min-width: 31.333%;
    max-width: 31.333%;
  }
  &:nth-child(1) label {border-radius: 4px 0 0 4px}
  &:nth-child(2) label{border-radius: 0 4px 4px 0}
}
.label-amount {
  font-weight: bold;
  padding: 10px;
  display: inline-block;
  color: #ff6000;
  letter-spacing: 0;
  font-size: 18px;
}
.label-description {
  font-weight: normal;
  padding: 0px;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  display: flex;
  line-height: 1.4;
}
</style>